export default __webpack_public_path__ + "static/media/Raider's Feral War Ring.afe3ec00.jpg";